var _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3680_48464",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 10C28 4.47715 23.5228 0 18 0H0V24H18C23.5228 24 28 19.5228 28 14V10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 10C29 3.92487 24.0751 -1 18 -1H0V1H18C22.9706 1 27 5.02944 27 10H29ZM0 25H18C24.0751 25 29 20.0751 29 14H27C27 18.9706 22.9706 23 18 23H0V25ZM18 25C24.0751 25 29 20.0751 29 14V10C29 3.92487 24.0751 -1 18 -1V1C22.9706 1 27 5.02944 27 10V14C27 18.9706 22.9706 23 18 23V25ZM0 0V24V0Z",
    fill: "#5F6D8C",
    mask: "url(#path-1-inside-1_3680_48464)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 7.66406C8.8471 7.66406 8.38079 7.85722 8.03697 8.20103C7.69315 8.54485 7.5 9.01117 7.5 9.4974V14.4974C7.5 14.9836 7.69315 15.4499 8.03697 15.7938C8.38079 16.1376 8.8471 16.3307 9.33333 16.3307H15C15.4862 16.3307 15.9525 16.1376 16.2964 15.7938C16.6402 15.4499 16.8333 14.9836 16.8333 14.4974V13.4347L19.1127 15.4647C19.6493 15.9427 20.5 15.5614 20.5 14.8421V8.9074C20.5 8.1874 19.6493 7.80673 19.1127 8.28473L16.8333 10.3147V9.4974C16.8333 9.01117 16.6402 8.54485 16.2964 8.20103C15.9525 7.85722 15.4862 7.66406 15 7.66406H9.33333Z",
    fill: "#5F6D8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.c684ff71bd10047b87484f07f9d922d5.svg";
export { ForwardRef as ReactComponent };